<!-- Diese Komponente zeigt eine statische Seite mit den Impressums-Informationen an. -->
<template>
  <main class="impressum-wrap">
    <section class="impressum-box">
      <h1>Wetter-Wetter | Impressum</h1>

      <div class="section">
        <h2>Angaben gemäß § 5 Digitale‑Dienste‑Gesetz (DDG)</h2>
        <p><strong>Wetter‑Wetter</strong> </p>
        <p><strong>POOSE Dashboard 1 — Informatik, Universität Bonn</strong></p>

        <h3>Projektbetreiber (natürliche Personen)</h3>
        <ul>
          <li>Hannes Gabelmann</li>
          <li>Tilo Behnke</li>
          <li>Christoph Lenz</li>
        </ul>

        <p><strong>Kontakt:</strong> <a :href="'mailto:' + contactEmail">{{ contactEmail }}</a></p>
      </div>

      <div class="section">
        <h2>Verantwortliche Personen für journalistisch‑redaktionelle Inhalte</h2>
        <p><strong>Nach § 55 Rundfunk‑ und Medienstaatsvertrag (RStV):</strong></p>
        <p>Hannes Gabelmann<br/>
          Tilo Behnke<br/>
          Christoph Lenz<br/>
        </p>
      </div>

      <div class="section">
        <h2>Umsatzsteuer / Register</h2>
        <p>Aktuell handelt es sich um ein universitäres Studienprojekt; es liegen keine Handelsregister‑ oder Umsatzsteuer‑Angaben vor. Falls zukünftig eine Eintragung oder USt‑ID vorliegt, wird diese hier ergänzt.</p>
      </div>

      <div class="section">
        <h2>Online‑Streitbeilegung (OS‑Plattform)</h2>
        <p>Die EU‑Plattform für Online‑Streitbeilegung (ODR) ist erreichbar; wir nehmen derzeit nicht an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil. Bitte kontaktieren Sie uns per E‑Mail bei Anliegen.</p>
      </div>

      <div class="section">
        <h2>Haftungshinweis</h2>
        <p>Trotz sorgfältiger inhaltlicher Kontrolle übernehmen die genannten Personen keine Haftung für die Inhalte externer Links. Dieses Impressum dient der Anbieterkennzeichnung gemäß den in Deutschland geltenden Vorschriften.</p>
      </div>

      <footer class="impressum-footer">
        <p><strong>Stand:</strong> 25.05.2026</p>
      </footer>
    </section>
  </main>
</template>

<script>
export default {
  name: 'ImpressumView',
  data() {
    return {
      contactEmail: 'support@wetter-wetter.de'
    };
  }
};
</script>

<style scoped>
/* Page is dark; show the impressum in a lighter box with left-aligned content */
.impressum-wrap {
  display: flex;
  justify-content: center;
  padding: 2rem 1rem;
  min-height: 60vh;
}

/* Light box contrasting the dark background */
.impressum-box {
  background: linear-gradient(180deg, #ffffffcc, #fafafa); /* slightly translucent white */
  color: #0b0b0b;
  max-width: 900px;
  width: 100%;
  border-radius: 12px;
  padding: 1.75rem;
  box-shadow: 0 6px 20px rgba(0,0,0,0.45);
  text-align: left; /* left-aligned inside the box */
}

/* Internal layout */
.impressum-box h1 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}
.impressum-box h2 {
  font-size: 1.05rem;
  margin-top: 1rem;
  margin-bottom: 0.4rem;
}
.impressum-box h3 {
  font-size: 0.98rem;
  margin-top: 0.6rem;
  margin-bottom: 0.3rem;
}

.section {
  margin-bottom: 0.9rem;
}

.impressum-box p, .impressum-box ul {
  margin: 0.35rem 0;
  line-height: 1.5;
}

.impressum-box ul {
  padding-left: 1.1rem;
}

.impressum-box a {
  color: #0a58e6;
  text-decoration: none;
}
.impressum-box a:hover {
  text-decoration: underline;
}

.impressum-footer {
  margin-top: 1.25rem;
  color: #333;
  font-size: 0.95rem;
  border-top: 1px solid rgba(0,0,0,0.06);
  padding-top: 0.75rem;
}
</style>
